const getExperiments = state => state.experiments;

export const isExperimentEnabled = (state, name) => getExperiments(state)[name] === 'true';
export const getExperimentValue = (state, name) => getExperiments(state)[name];
